import { z } from 'zod'
import { orderBookTickSchema } from './order-book-tick.schema'
import { candleSchema } from './candle.schema'

export const instrumentStreamEventSchema = z.discriminatedUnion('type', [
  z.object({
    type: z.literal('price'),
    instrumentUid: z.string(),
    price: z.number(),
    ts: z.string(),
  }),
  orderBookTickSchema.extend({ type: z.literal('orderbook') }),
  candleSchema.extend({ type: z.literal('candle'), instrumentUid: z.string() }),
])
export type InstrumentStreamEventDto = z.infer<typeof instrumentStreamEventSchema>
